const $ = jQuery;

const ShowMore = {
  init: () => {

    const filters = document.querySelector(".products-wrapper");
    if (!filters) return;

 
    const tags = document.querySelectorAll(".product-item");
    const showMore = document.querySelector(".show-more-btn");
    const showTextMore = showMore.querySelector(".show-text.more");
    const showTextLess = showMore.querySelector(".show-text.less");

    tags.forEach((tag, index) => {
      if (index <= 3) {
        tag.classList.add("active");
      }
    });

    let currentVisibleIndex = 3;

    
    showMore.addEventListener("click", (e) => {
      e.preventDefault();

      if (showTextMore.style.display !== "none") {
       
        let newLimit = tags.length - 1;
        tags.forEach((tag, index) => {
          if (index <= newLimit) {
            tag.classList.add("active");
          }
        });

        currentVisibleIndex = newLimit;

        if (currentVisibleIndex >= tags.length - 1) {
          showTextMore.style.display = "none";
          showTextLess.style.display = "inline";
        }
      } else {
 
        tags.forEach((tag, index) => {
          if (index > 3) {
            tag.classList.remove("active");
          }
        });

        currentVisibleIndex = 3;
        showTextMore.style.display = "inline";
        showTextLess.style.display = "none";
      }
    });
  },
};

export default ShowMore;
